import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthenticationService} from '../_services/authentication.service';

@Injectable({
  providedIn: 'root'
})
export class FirstJwtGuard  {
  private router = inject(Router);
  private authenticationService = inject(AuthenticationService);


  private authTokenExists: boolean = false;

  constructor() {
    this.authenticationService.decodedAuthToken$.subscribe(jwt => this.authTokenExists = !!jwt);
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.authTokenExists || this.router.createUrlTree(['/login'], {queryParams: {returnUrl: state.url}});
  }

}
